/** Typing for ContactList column definitions */

/**
 * @param options {Object}
 * @param options.value {string|function} What to show in cells in the column. Can be function or string for property
 * on contact
 * @param options.subRowValue {string|function|undefined} Override of value for subrows. Set to '' to show nothing
 * @param options.type {string|undefined}
 * @param options.columnClassNames Classes for cells in the column.
 * @param options.header {string|function} what to show in header cells
 * @param options.sortName {string|undefined}
 * @param options.sort {object|undefined} The selected sort (has column and order properties)
 * @param options.onSort {function|undefined} function that is called on a column's sortName on click
 * @param options.fontAwesomeIcon {string} Font Awesome icon to be added before the value
 */
const defaultColumn = ({
  value, subRowValue, type, columnClassNames, header, sortName, sort, onSort, fontAwesomeIcon
}) => ({
  value,
  subRowValue,
  type,
  columnClassNames,
  header,
  sortName,
  sort,
  onSort,
  fontAwesomeIcon
});

/**
 * @param options {Object}
 * @param options.value {string|function} What to show in cells in the column. Can be function or string for property
 * on contact
 * @param options.subRowValue {string|function|undefined} Override of value for subrows. Set to '' to show nothing
 * @param options.columnClassNames Classes for cells in the column.
 * @param options.header {string|function} what to show in header cells
 * @param options.sortName {string|undefined}
 * @param options.sort {object|undefined} The selected sort (has column and order properties)
 * @param options.onSort {function|undefined} function that is called on a column's sortName on click
 * @param options.defaultToZero {boolean|undefined} Whether to show $0 instead of nothing when value is blank
 */
const currencyColumn = ({
  value, subRowValue, columnClassNames, header, sortName, sort, onSort, defaultToZero
}) => ({
  type: 'currency',
  defaultToZero,
  value,
  subRowValue,
  columnClassNames,
  header,
  sortName,
  sort,
  onSort
});

/**
 * @param options {Object}
 * @param options.value {string|function} What to show in cells in the column. Can be function or string for property
 * on contact
 * @param options.subRowValue {string|function|undefined} Override of value for subrows. Set to '' to show nothing
 * @param options.type {string|undefined}
 * @param options.columnClassNames Classes for cells in the column.
 * @param options.header {string|function} what to show in header cells
 * @param options.sortName {string|undefined}
 * @param options.sort {object|undefined} The selected sort (has column and order properties)
 * @param options.onSort {function|undefined} function that is called on a column's sortName on click
 */
const dateColumn = ({
  value, subRowValue, columnClassNames, header, sortName, sort, onSort
}) => ({
  type: 'date',
  value,
  subRowValue,
  columnClassNames,
  header,
  sortName,
  sort,
  onSort
});

/**
 * @param options {Object}
 * @param options.value {function} function to get display text for link based on contact
 * @param options.subRowValue {function|undefined} Override of value for subrows
 * @param options.link {string|function} string or function to get href for link based on contact
 * @param options.newTab {boolean|undefined} whether to open link in new tab
 * @param options.columnClassNames Classes for cells in the column
 * @param options.header {string|function} what to show in header cells
 * @param options.sortName {string|undefined}
 * @param options.sort {object|undefined} The selected sort (has column and order properties)
 * @param options.onSort {function|undefined} function that is called on a column's sortName on click
 * @param options.fontAwesomeIcon {string} Font Awesome icon to be added before the value
 */
const linkColumn = ({
  value, subRowValue, link, newTab, columnClassNames, header, sortName, sort, onSort, fontAwesomeIcon
}) => ({
  type: 'link',
  value,
  subRowValue,
  columnClassNames,
  header,
  sortName,
  sort,
  onSort,
  link,
  newTab,
  fontAwesomeIcon
});

/**
 * @param options {Object|undefined}
 * @param options.columnClassNames Classes for cells in the column.
 */
const expanderColumn = ({ columnClassNames }) => ({
  header: '',
  type: 'expander',
  columnClassNames
});

/**
 * @param options {Object}
 * @param options.value {string|function} Will show checkbox if this has a value or is a function that returns true
 * @param options.subRowValue {string} Set to '' to not show checkbox
 * @param options.columnClassNames Classes for cells in the column.
 * @param options.itemIsSelected {function} from useBulkActions
 * @param options.toggleTrackedItem {function} from useBulkActions
 * @param options.selectionMode {string} from useBulkActions
 * @param options.promptSelectAll {boolean|undefined} from useBulkActions
 * @param options.togglePageTracked {function} from useBulkActions
 */
const bulkCheckboxColumn = ({
  value,
  subRowValue,
  columnClassNames,
  itemIsSelected,
  toggleTrackedItem,
  selectionMode,
  promptSelectAll,
  togglePageTracked
}) => ({
  type: 'bulkCheckbox',
  itemIsSelected,
  toggleTrackedItem,
  selectionMode,
  promptSelectAll,
  togglePageTracked,
  value,
  subRowValue,
  columnClassNames
});

export {
  defaultColumn,
  currencyColumn,
  linkColumn,
  dateColumn,
  bulkCheckboxColumn,
  expanderColumn
};
